import Vue from 'vue'
import store from '@/store'
import CashRegisterService from '@/services/CashRegisterService';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

const packageJson = require('/package.json');

const ErrorReporter = {

    shouldReportErrors: false,
    timers: {},

    init() {
        this.shouldReportErrors = process.env.VUE_APP_ENV === 'production' && !!process.env.VUE_APP_SENTRY_VUE_DSN
    },

    /**
     * Set up error reporting
     */
    setUpErrorReporting() {
        if(!this.shouldReportErrors) return

        Sentry.init({
            Vue: Vue,
            dsn: process.env.VUE_APP_SENTRY_VUE_DSN,
            // integrations: [ new Integrations.BrowserTracing() ],
            // tracesSampleRate: 0.1,
            ignoreErrors: [
                'Request failed with status code 401',
                'Request failed with status code 422',
                'The node to be removed is not a child of this node',
                'Failed to update a ServiceWorker for scope',
                'Error Status 404: App not found',
            ],
            logErrors: true,
            beforeSend: event => {
                event.tags = !event.tags ? this.getErrorData() : { ...event.tags, ...this.getErrorData() }
                event.tags.efectiveEnvironment = process.env.VUE_APP_ENV
                // event.extra = { ...event.extra, ...this.getErrorData() }
                return event
            }
        });
    },

    /**
     * Report Error to Sentry
     */
    reportError(error, data = null) {
        if(!this.shouldReportErrors) return

        Sentry.withScope(function(scope) {
            if(data) {
                scope.setExtras(data);
            }
            Sentry.captureException(error)
        });
    },

    /**
     * Report Message to Sentry
     */
    reportMessage(message, data = null) {
        if(!this.shouldReportErrors) return

        Sentry.withScope(function(scope) {
            if(data) {
                scope.setExtras(data);
            }
            Sentry.captureMessage(message)
        });
    },

    /**
     * Get additional data to be reported with the error
     */
    getErrorData() {
        return {
            tenant: store.getters.tenant ? store.getters.tenant.email : 'none',
            user: store.getters.user ? store.getters.user.name : 'none',
            cashRegister: CashRegisterService.getId() || 'none',
            appName: packageJson.name,
            electronAppRelease: store.getters.device && store.getters.device.electron ? store.getters.device.electron.appVersion : null
        }
    },

    time(timerName = 'default') {
        if(this.timers[timerName]) {
            console.warn('Timer ' + timerName + ' already started!');
            this.timeEnd(timerName, 5000, 'FORCE END')
        }

        this.timers[timerName] = { startTime: performance.now(), log: [] }
    },

    timeLog(timerName = 'default', prefix) {
        if(!this.timers[timerName]?.startTime) return

        const duration = Math.round(performance.now() - this.timers[timerName].startTime) / 1000;
        const log = `[${prefix}] ${duration} [${timerName}]`;
        this.timers[timerName].log.push(log);

        return this.timers[timerName];
    },

    timeEnd(timerName = 'default', reportLimit = null, prefix = null, timerNameToReport = null, dataToReport = {}) {
        if(!this.timers[timerName]?.startTime) return

        const duration = Math.round(performance.now() - this.timers[timerName].startTime) / 1000;
        const log = `[${prefix || 'END'}]: ${duration} [${timerName}]`;
        this.timers[timerName].log.push(log);
        this.timers[timerName].duration = duration;

        const timer = this.timers[timerName];
        delete timer.startTime;
        delete this.timers[timerName];

        if(reportLimit && duration * 1000 > reportLimit) {
            if(!timerNameToReport) {
                timerNameToReport = timerName;
            }

            this.reportMessage(`Timer over the limit: ${timerNameToReport}`, {
                ...timer,
                reportLimit,
                ...dataToReport
            })
        }

        return timer;
    }
}

export default ErrorReporter

export { ErrorReporter }
